import axios from 'axios';
import { API_HOST } from '../../../consts';

export default (params) =>
  axios
    .get(`${API_HOST}/tickets/forwardings`, { params })
    .then((res) => res.data);
